export const TRACKING_DISPLAYS = [
  'live',
  'precise',
  'coarse',
  'offDuty',
  'noPermission',
  'unknown',
] as const;

export type TrackingDisplay = (typeof TRACKING_DISPLAYS)[number];

export interface TrackingStateSnapshot {
  tier?: string;
  reason?: string;
  permission?: string;
  updatedAt?: number;
}

const NO_PERMISSION = new Set(['denied', 'gps_off', 'gpsOff', 'disabled', 'noPermission']);

/** Panel label for the app-written trackingState. Missing state stays unknown. */
export const resolveTrackingDisplay = (
  state?: TrackingStateSnapshot | null,
): TrackingDisplay => {
  if (!state) return 'unknown';
  if (state.permission && NO_PERMISSION.has(state.permission)) return 'noPermission';
  if (state.tier === 'off' || state.reason === 'offDuty') return 'offDuty';
  if (state.tier === 'live') return 'live';
  if (state.tier === 'precise') return 'precise';
  if (state.tier === 'coarse' || state.tier === 'oneShot') return 'coarse';
  return 'unknown';
};

export const isCurrentPosition = (display: TrackingDisplay): boolean =>
  display !== 'offDuty' && display !== 'noPermission';
